import { useCallback, useEffect, useState } from 'react';
import useLinkedStudiesApi from '../../api/requests/useLinkedStudiesApi';

/**
 * Parent requests (study notifications) the given sub-workflow request is linked to.
 */
const useRequestParentRequests = (requestId, enabled = true) => {
  const { getRequestParentRequests } = useLinkedStudiesApi();
  const [parentRequests, setParentRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchParentRequests = useCallback(async () => {
    if (!requestId || !enabled) return;
    setLoading(true);
    try {
      const response = await getRequestParentRequests(requestId);
      setParentRequests(response?.data || []);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to load study notifications');
    } finally {
      setLoading(false);
    }
  }, [requestId, enabled, getRequestParentRequests]);

  useEffect(() => {
    fetchParentRequests();
  }, [fetchParentRequests]);

  return { parentRequests, loading, error };
};

export default useRequestParentRequests;
